import { states } from 'components/core/Input';

export function setInputState(hasUniquepepId, isValid) {
  if (!isValid && hasUniquepepId) return states.error;

  if (hasUniquepepId) return states.default;

  return states.disabled;
}
